import React, { Component } from "react";
import { Icon, Row, Select } from "antd";
import { PropTypes } from 'prop-types';
import guideStarLogo from "../../../../assets/icons/GuideStar-logo.svg";
import { CustomCheckbox, CustomSelectBox } from '../../../commonStyles';
import TooltipComponent from "../../../Info/Tooltip/TooltipComponent";
import { Box } from "../../styles";
import FilterSlider from "../FilterSlider/FilterSlider";
import { Gpl } from "./gpl.js";
import { Irs } from "./irs.js";
import { Major } from "./major.js";
import { Minor } from "./minor.js";
import { BottomWrapper, CloseText, FilterCol, FilterColAff, FlexBox, PoweredBy, TabTitles } from "./styles";
import { recordError } from "../../../../utils/commonUtil";

const Option = Select.Option;
const children = [];
for (let i = 10; i < 36; i++) {
  children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
}
const ConfigOrg = [
  {
    title: "GuideStar profile level",
    mode: "multiple",
    placeholder: "Filter by GuideStar profile level",
    key: "profile_levels",
    options: "guideProfile",
    filterSet: false,
    tooltip: true
  },
  {
    title: "Cause Area (NTEE Category)",
    mode: "multiple",
    placeholder: "Filter by cause area",
    key: "ntee_major_codes",
    options: "majorData",
    filterSet: false
  },
  {
    title: "Subcause Area (NTEE Code)",
    mode: "multiple",
    placeholder: "Filter by subcause area",
    key: "ntee_minor_codes",
    options: "minorData",
    filterSet: false
  },
  {
    title: "IRS Subsection",
    mode: "multiple",
    placeholder: "Filter by IRS Subsection",
    key: "subsection_codes",
    options: "irsData",
    filterSet: false
  }
];

const ConfigOrgSelectType = [
  {
    label: "IRS Form Type: Form 990",
    key: "f990"
  },
  {
    label: "IRS Form Type: Form 990 PF",
    key: "f990pf"
  },
  {
    label: "Required to File IRS Form 990T",
    key: "required_to_file_990t"
  }
];

const ConfigOrgAffiliationType = [
  {
    label: "Parent",
    key: "parent"
  },
  {
    label: "Subordinate",
    key: "subordinate"
  },
  {
    label: "Independent",
    key: "independent"
  },
  {
    label: "Headquarter",
    key: "headquarter"
  }
];

const ConfigOrgSpecificEx = [
  {
    label: "Exclude revoked organizations",
    key: "exclude_revoked_organizations"
  },
  {
    label: "Exclude defunct and merged organizations",
    key: "exclude_defunct_or_merged_organizations"
  }
];

 

const minorArr =  Minor.map((obj, index) => {
    return (
      <Option key={obj.name} value={obj.name} title={obj.name}>
        {obj.name}
      </Option>
    );
  });



  const majorArr =  Major.map((obj, index) => {
    return (
      <Option key={obj.name} value={obj.name} title={obj.name}>
        {obj.name}
      </Option>
    );
  });




  const irsArr  =  Irs.map((obj, index) => {
    return (
      <Option key={obj.name} value={obj.name} title={obj.name}>
        {obj.name}
      </Option>
    );
  });

  const gplArr =  Gpl.map((obj, index) => {
    return (
      <Option key={obj.name} value={obj.name} title={obj.name}>
        {obj.name}
      </Option>
    );
  });


export default class Organizations extends Component {
  state = {
    guideProfile: gplArr,
    majorData: majorArr,
    irsData: irsArr,
    minorDataArray: [],
    majorDataArray: [],
    a: [],
    disabled: true
  };

  handleClick = e => {
    if (this.node.contains(e.target)) {
      return;
    }
    let elem = document.querySelector(".OrgPopup");
    elem.style.display = "none";
  };

  stateChange = (value, id) => {
    if (`${id}` === "ntee_major_codes") {
      this.setState({ majorDataArray: value });
      this.filteredMinorData(value);
    }

    if (`${id}` === "ntee_minor_codes") {
      this.setState({ minorDataArray: value });
    }

    this.props.updateStateFunc(value, id);
  };

  filteredMinorData = data => {
    const filteredData = [];
    if (data.length === 0) {
      filteredData.length = 0;
    }
    data.map(majorValue => {
      let mval = majorValue;
      minorArr.forEach(minorValue => {
        if (majorValue[0] === minorValue.key[0]) {
          filteredData.push(minorValue.key);
        }
      });
    });

    this.setState({ a: filteredData }, () => { });
  };

  closeFunc = index => {
    try {
      this.props.closeOption(index);
    } catch (error) {
      recordError(error);
    }
  };

  onChange = (e, key) => {
    this.props.updateStateFunc(e.target.checked, key);
  };

  valueChange = (values, key, max) => {
    this.props.updateStateFunc(values, key, max);
  };

  sliderStatus = value => {
    this.props.sliderStatus(value);
  };

  render() {
    const { disabled } = this.state;
    const { isFull } = this.props;
    let filData = this.state.a.map((obj, index) => {
      return (
        <Option value={obj} key={index} title={obj}>
          {obj}
        </Option>
      );
    });
    return (
      <Box
        className="OrgPopup"
        ref={node => (this.node = node)}
        left={this.props.isFull ? 83 : 79}
      >
        <Row gutter={16}>
          {ConfigOrg.map((obj, index) => {
            const dummystate = obj.key;
            const childData = obj.options;
            return (
              <FilterCol id="area" className="gutter-row" lg={8}>
                <TabTitles>
                  {obj.title}
                  {obj.tooltip && <TooltipComponent text="The amount of information a nonprofit has directly shared on its GuideStar Nonprofit Profile is indicated by its Seal of Transparency." />}
                </TabTitles>
                {index === 2 ? (
                  <CustomSelectBox
                    dropdownClassName="advisorSel"
                    width={isFull ? "300" : "221"}
                    value={this.props.tabFilters[dummystate]}
                    placeholder="Filter by subcause area"
                    onChange={event => this.stateChange(event, obj.key)}
                    mode={obj.mode}
                    getPopupContainer={() => document.getElementById("area")}
                    showArrow
                  >
                    {filData}
                  </CustomSelectBox>
                ) : (
                    <CustomSelectBox
                      dropdownClassName="advisorSel"
                      value={this.props.tabFilters[dummystate]}
                      showArrow
                      mode={obj.mode}
                      width={isFull ? "300" : "220"}
                      placeholder={obj.placeholder}
                      onChange={event => this.stateChange(event, obj.key)}
                      getPopupContainer={() => document.getElementById("area")}
                      key={obj.key}
                    >
                      {this.state[childData]}
                    </CustomSelectBox>
                  )}
              </FilterCol>
            );
          })}
        </Row>
        <Row gutter={16}>
          <FilterColAff className="gutter-row" lg={8}>
            <FilterSlider
              key="number_of_employees_range"
              title="No. of employees"
              slideValues={(values, max, disableFlag) =>
                this.valueChange(values, "number_of_employees_range", max)
              }
              sliderStatus={value => this.sliderStatus(value)}
              min={0}
              max={3500}
              minValue={
                this.props.tabFilters.number_of_employees_range === undefined
                  ? 0
                  : this.props.tabFilters.number_of_employees_range.min
              }
              maxValue={
                this.props.tabFilters.number_of_employees_range === undefined
                  ? 3500
                  : this.props.tabFilters.number_of_employees_range.max
              }
              setDisable
            />
          </FilterColAff>
        </Row>
        <Row gutter={16}>
          <TabTitles> Affiliation Type</TabTitles>
          {ConfigOrgAffiliationType.map((obj, index) => {
            const keyValue = obj.key;

            return (
              <FilterCol className="gutter-row" lg={6} float>
                <FlexBox>
                  <CustomCheckbox
                    key={obj.key}
                    checked={this.props.tabFilters.affiliation_type[keyValue]}
                    onChange={event => this.onChange(event, obj.key)}
                  >
                    {obj.label}
                  </CustomCheckbox>
                </FlexBox>
              </FilterCol>
            );
          })}
        </Row>

        <Row gutter={16}>
          <TabTitles> Select Type</TabTitles>
          {ConfigOrgSelectType.map((obj, index) => {
            const keyValue = obj.key;
            return (
              <FilterCol className="gutter-row" lg={6} float>
                <FlexBox>
                  <CustomCheckbox
                    key={obj.key}
                    checked={this.props.tabFilters.form_types[keyValue]}
                    onChange={event => this.onChange(event, obj.key)}
                  >
                    {obj.label}
                  </CustomCheckbox>
                </FlexBox>
              </FilterCol>
            );
          })}
          <FilterCol className="gutter-row" lg={6}>
            <CustomCheckbox
              key="a_133_audit_performed"
              checked={this.props.tabFilters.audits["a_133_audit_performed"]}
              onChange={event => this.onChange(event, "a_133_audit_performed")}
            >
              A-133 Audit Performed
            </CustomCheckbox>
          </FilterCol>
        </Row>

        <Row gutter={16}>
          <TabTitles> Specific Exclusion</TabTitles>
          {ConfigOrgSpecificEx.map((obj, index) => {
            const keyValue = obj.key;
            return (
              <FilterCol className="gutter-row" lg={12} float>
                <CustomCheckbox
                  key={obj.key}
                  checked={this.props.tabFilters.specific_exclusions[keyValue]}
                  onChange={event => this.onChange(event, obj.key)}
                >
                  {obj.label}
                </CustomCheckbox>
              </FilterCol>
            );
          })}
        </Row>
        <BottomWrapper>
          <PoweredBy>
            <span>Powered By</span>
            <img src={guideStarLogo} alt="Vangaurd" />
          </PoweredBy>
          <CloseText
            key="closeText"
            onClick={index => this.closeFunc(this.props.index)}
          >
            Close <Icon type="close" />
          </CloseText>
        </BottomWrapper>
      </Box>
    );
  }
}

Organizations.propTypes = {
  closeOption: PropTypes.func,
  fromPage: PropTypes.string,
  geminiFilterData: PropTypes.func,
  index: PropTypes.number,
  isFull: PropTypes.bool,
  sliderStatus: PropTypes.func,
  tabFilters: PropTypes.shape({
    affiliation_type: PropTypes.object,
    audits: PropTypes.object,
    bmf_status: PropTypes.bool,
    form_types: PropTypes.object,
    foundation_codes: PropTypes.array,
    ntee_major_codes: PropTypes.array,
    ntee_minor_codes: PropTypes.array,
    number_of_employees_range: PropTypes.object,
    profile_levels: PropTypes.array,
    pub78_verified: PropTypes.bool,
    specific_exclusions: PropTypes.object,
    subsection_codes: PropTypes.array,
  }),
  updateStateFunc: PropTypes.func,
}